import styled from "styled-components";

export const FloorPlansWrapper = styled("div")`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #535d53;
`;
